<script setup lang="ts">
interface SortOption {
  key: string
  label: string
  [key: string]: unknown
}

defineProps<{
  sort: string
  sortOptions: SortOption[]
}>()

defineEmits(['updateSort'])

const isOpen = ref(false)
</script>

<template>
  <div
    v-if="sort && sortOptions?.length && sortOptions.length > 1"
    class="sort"
  >
    <template v-if="0">
      <label
        for="paginator-sort"
        class="sort__label"
      >{{ $t('Sort by') }}</label>
      <select
        id="paginator-sort"
        class="sort__select"
        @input="(event) => $emit('updateSort', (event.target as HTMLInputElement).value)"
      >
        <option
          v-for="option in sortOptions"
          :key="`sort-${option.key}`"
          :value="option.key"
          :selected="option.key === sort"
        >
          {{ $t(option.label) }}
        </option>
      </select>
    </template>

    <UiCollapsable
      v-else
      :open="isOpen"
      @toggle="isOpen = !isOpen"
    >
      <template #label>
        <span class="sort__label">{{ $t('Sort by') }}&nbsp;</span>
        <span class="sort__value">
          {{ $t(sortOptions.find(opt => opt.key === sort)?.label || '') }}
        </span>
        <Icon
          name="icon:chevron"
          class="collapsable__icon icon icon--arrow"
          :class="{ 'icon--arrow-bottom': !isOpen, 'icon--arrow-top': isOpen }"
        />
      </template>
      <ul
        class="sort__select"
        role="menu"
        :aria-label="$t('Sort options')"
      >
        <li
          v-for="option in sortOptions"
          :key="`sort-${option.key}`"
          class="sort__option"
          :class="{ 'sort__options--selected': option.key === sort }"
          role="none"
        >
          <button
            type="button"
            class="sort__button"
            role="menuitem"
            :aria-current="option.key === sort ? 'true' : 'false'"
            :aria-label="`${$t('Sort by')} ${$t(option.label)}`"
            @click="$emit('updateSort', option.key)"
          >
            <Icon
              v-if="option.key === sort"
              name="icon:check"
              class="sort__icon icon icon--check"
              aria-hidden="true"
            />

            {{ $t(option.label) }}
          </button>
        </li>
      </ul>
    </UiCollapsable>
  </div>
</template>

<style>
@import url("~layers/app/components/Paginator/Sort.css");
</style>
